import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

const LoadingSpinner = (props) => (
  <div className="loading-spinner fadeInDown animResponse">
    <Icon loading name='spinner' size='huge' />
      {props.showText ? (
          <p>
              <FormattedMessage  id={`loading${props.textKey ? `.${props.textKey}` : ''}`} />
          </p>
      ) : ""}
  </div>
);

LoadingSpinner.propTypes = {
  textKey: PropTypes.string,
    showText: PropTypes.bool
};

LoadingSpinner.defaultProps = {
    showText: true
}

export default LoadingSpinner;


// WEBPACK FOOTER //
// ./public/components/common/LoadingSpinner.jsx